















import { Component, Vue, Prop } from 'vue-property-decorator';
@Component({
    name: 'c-pop-up'
})
export default class CPopUp extends Vue {
    @Prop({
        required: false,
        default: null
    })
    private flk!: any;

    @Prop({
        required: false,
        default: ''
    })
    private fieldName!: string;

    private get errorLst() {
        if (this.flk && this.flk[this.fieldName]) {
            return this.flk[this.fieldName];
        }
        return [];
    }
    private getErrorClass(elErr: any) {
        const prefix = elErr.typeErr === 'error' ? 'strong-color' : 'color';
        const colorMap: { [key: number]: string } = {
            1: `${prefix}-1`,
            2: `${prefix}-2`,
            3: `${prefix}-3`,
            4: `${prefix}-4`,
            6: `${prefix}-6`
        };
        return colorMap[elErr.id] || 'default-color';
    }
}

